import TableAlertAction from '../AlertItem/TableAlertAction';
import AGGridHeader from '../../../../views/AGGrid/AGGridHeader';

export const ALERT_TYPE_TENANT_CONTRACT_EXPIRATION_COLS_DEF = [
  {
    field: 'portfolioname',
    headerName: 'Portfolio',
    filter: 'agSetColumnFilter',
    headerComponent: AGGridHeader
  },
  {
    field: 'assetname',
    headerName: 'Asset',
    filter: 'agSetColumnFilter',
    headerComponent: AGGridHeader
  },
  {
    field: 'tenantname',
    headerName: 'Tenant',
    filter: 'agSetColumnFilter',
    headerComponent: AGGridHeader
  },
  {
    field: 'leaseEndDate',
    headerName: 'Expire Date',
    filter: 'agDateColumnFilter',
    valueFormatter: dateFormatter,
    headerComponent: AGGridHeader
  },
  {
    headerName: 'Actions',
    cellRenderer: TableAlertAction,
    cellRendererParams: (params) => {
      const entityId = params.data.entityid;
      return {
        entityId,
        url: `/Tenants/${entityId}/Options`,
        type: ALERT_TYPE_TENANT_CONTRACT_EXPIRATION
      };
    },
    width: 300,
    hide: true
  }
];

export const ALERT_TYPE_TENANT_CONTRACT_BREAK_COLS_DEF = [
  {
    field: 'portfolioname',
    headerName: 'Portfolio',
    filter: 'agSetColumnFilter',
    headerComponent: AGGridHeader
  },
  {
    field: 'assetname',
    headerName: 'Asset',
    filter: 'agSetColumnFilter',
    headerComponent: AGGridHeader
  },
  {
    field: 'tenantname',
    headerName: 'Tenant',
    filter: 'agSetColumnFilter',
    headerComponent: AGGridHeader
  },
  {
    field: 'leaseEndDate',
    headerName: 'Lease Break',
    valueFormatter: dateFormatter,
    filter: 'agDateColumnFilter',
    headerComponent: AGGridHeader
  },
  {
    headerName: 'Actions',
    cellRenderer: TableAlertAction,
    cellRendererParams: (params) => {
      const entityId = params.data.entityid;
      return {
        entityId,
        url: `/Tenants/${entityId}/Options`,
        type: ALERT_TYPE_TENANT_CONTRACT_EXPIRATION
      };
    },
    width: 300,
    hide: true
  }
];

export const ALERT_TYPE_VACANT_UNITS_COLS_DEF = [
  {
    field: 'portfolioname',
    headerName: 'Portfolio',
    filter: 'agSetColumnFilter',
    headerComponent: AGGridHeader
  },
  {
    field: 'assetname',
    headerName: 'Asset',
    filter: 'agSetColumnFilter',
    headerComponent: AGGridHeader
  },
  { field: 'unit', headerName: 'Unit', filter: 'agSetColumnFilter', headerComponent: AGGridHeader },
  { field: 'gla',
    headerName: 'GLA',
    filter: 'agNumberColumnFilter',
    valueFormatter: (params) => {
      if (params.value == null || params.value === '') {
        return '';
      }

      return Math.round(params.value).toLocaleString();
    },
    headerComponent: AGGridHeader
  },
  { field: 'date', headerName: 'Date', filter: 'agSetColumnFilter', headerComponent: AGGridHeader },
  {
    headerName: 'Actions',
    cellRenderer: TableAlertAction,
    cellRendererParams: (params) => {
      const entityId = params.data.entityid;
      return {
        entityId,
        url: undefined,
        type: ALERT_TYPE_VACANT_UNITS
      };
    },
    width: 300,
    hide: true
  }
];

export const ALERT_TYPE_OPEX_COLS_DEF = [
  {
    field: 'portfolioname',
    headerName: 'Portfolio',
    filter: 'agSetColumnFilter',
    headerComponent: AGGridHeader
  },
  {
    field: 'assetname',
    headerName: 'Asset',
    filter: 'agSetColumnFilter',
    headerComponent: AGGridHeader
  },
  {
    field: 'opexName',
    headerName: 'Opex Name',
    filter: 'agSetColumnFilter',
    headerComponent: AGGridHeader
  },
  {
    field: 'supplier',
    headerName: 'Supplier',
    filter: 'agSetColumnFilter',
    headerComponent: AGGridHeader
  },
  {
    field: 'opexContractedData',
    headerName: 'Contract End Date',
    valueFormatter: dateFormatter,
    filter: 'agDateColumnFilter'
  },
  {
    headerName: 'Actions',
    cellRenderer: TableAlertAction,
    cellRendererParams: (params) => {
      const entityId = params.data.entityid;
      const assetId = params.data.assetid;
      return {
        entityId,
        url: `/Asset/${assetId}/OpexManager`,
        type: ALERT_TYPE_OPEX_CONTRACT_EXPIRATION
      };
    },
    width: 300,
    hide: true
  }
];

// alert types
export const ALERT_TYPE_TENANT_CONTRACT_EXPIRATION = 1;
export const ALERT_TYPE_VACANT_UNITS = 3;
export const ALERT_TYPE_TENANT_CONTRACT_BREAK = 4;
export const ALERT_TYPE_OPEX_CONTRACT_EXPIRATION = 5;

// category types
export const ALERT_CATEGORY_ASSET_MANAGEMENT = 1;
export const ALERT_CATEGORY_PROPERTY_MANAGEMENT = 2;

function dateFormatter(params) {
  if (params.value == null || params.value === '') {
    return '';
  }

  const date = new Date(params.value);

  return `${date.getDate()} ${date.toLocaleString('default', {
    month: 'short'
  })}, ${date.getFullYear()}`;
}
